import { useMutation, useQueryClient } from '@tanstack/react-query';

import { customAxios } from 'lib/axios';

const deleteVersion = async (versionId: string): Promise<void> => {
  await customAxios.delete(`/versions/${versionId}`);
};

export const useDeleteVersion = (orgId: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteVersion,
    onSuccess: () => {
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      queryClient.invalidateQueries({ queryKey: ['versions', orgId] }).catch(() => undefined);
    },
  });
};
